







import { Component, Vue } from 'vue-property-decorator';
import TodoFormList from './components/todoFormList.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import { todoListInstance } from '@/model/TodoListClass';

@Component({
  components: {
    TodoFormList,
  },
})
export default class CreateTodo extends Vue {
  get todoForCreate() {
    return todoListInstance.todoForCreate;
  }
  private goBack() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({name: 'Todo'});
  }
}
